import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@storable/canaveral-components';
import { AMENITY_ICON_IDS, AMENITY_IDS, FALLBACK_ID } from './icons';

const propTypes = {
  className: PropTypes.string,
  context: PropTypes.string,
  id: PropTypes.oneOf(AMENITY_IDS).isRequired,
  label: PropTypes.string,
};

const defaultProps = {
  className: undefined,
  context: undefined,
  label: undefined,
};

const AmenityIcon = ({
  className,
  context,
  id,
  label,
  ...rest
}) => (
  <Icon
    {...rest}
    className={className}
    context={context}
    id={AMENITY_ICON_IDS[id] || AMENITY_ICON_IDS[FALLBACK_ID]}
    label={label}
  />
);

AmenityIcon.propTypes = propTypes;
AmenityIcon.defaultProps = defaultProps;

AmenityIcon.fragments = {};

export default AmenityIcon;
